// extracted by mini-css-extract-plugin
module.exports = {"articleWrapper":"posts_articleWrapper__3lEWQ","west":"posts_west___iSaY","east":"posts_east__1P5wm"};